import Constant from '../../const';
const axios = require('axios');

const getDashboardPcareData = async params => {
  try {
    const response = await axios.get(Constant.apiUrl.concat('/pcare/report'), {
      params,
    });
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getDashboardPcareData;
